.event-timeline-component-type.full-screen .event-timeline-panel {
  height: calc(100vh - 69px - 2rem - 2rem - 56px - 2rem);
}
.event-timeline-component-type.full-screen .event-timeline-panel .event-timeline-event-list .split {
  min-height: 200px;
}

.event-timeline-panel {
  user-select: none;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.event-timeline-panel .event-timeline-outer-container {
  flex: 1 1 auto;
  min-height: 0;
}
.event-timeline-panel .drop-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 15rem;
  position: relative;
}
.event-timeline-panel .drop-wrapper:focus {
  outline: none;
}
.event-timeline-panel .drop-wrapper > div:not(:first-child):not(.drop-zone) + div {
  margin-top: 1rem;
}
.event-timeline-panel .drop-wrapper .drop-zone {
  position: absolute;
  padding: 1rem;
  border: 2px dashed gray;
  display: flex;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  z-index: 100;
}
.event-timeline-panel .event-timeline-view > div > svg {
  cursor: crosshair;
}
.event-timeline-panel .event-timeline-brush svg {
  overflow: visible;
}

.event-timeline-info-header {
  display: flex;
  justify-content: space-between;
  color: rgb(50%, 50%, 50%);
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
}
.event-timeline-info-header.over-chart div:first-child {
  margin-left: 70px;
}
.event-timeline-info-header.over-list div:first-child {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.event-timeline-info-header .event-timeline-legend li {
  float: left;
  margin-right: 0.5rem;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.event-timeline-info-header .event-timeline-legend li svg {
  margin-right: 0.25rem;
}
.event-timeline-info-header .event-timeline-info .limited-event-info {
  position: relative;
  display: flex;
  align-items: center;
}
.event-timeline-info-header .event-timeline-info .limited-event-info .info-text {
  margin-right: 0.5rem;
}
.event-timeline-info-header .event-timeline-info .limited-event-info-trigger.user div.avt-react-components--icon, .event-timeline-info-header .event-timeline-info .limited-event-info-trigger.iot div.avt-react-components--icon {
  margin-left: 0;
}
.event-timeline-info-header .event-timeline-info .limited-event-info-trigger.user .event-info-icon, .event-timeline-info-header .event-timeline-info .limited-event-info-trigger.iot .event-info-icon {
  color: #3366ff;
}
.event-timeline-info-header .event-timeline-info .limited-event-info-trigger.user:hover + div, .event-timeline-info-header .event-timeline-info .limited-event-info-trigger.iot:hover + div {
  display: block;
  position: absolute;
  top: -5rem;
  right: 1.5rem;
}
.event-timeline-info-header .event-timeline-info .limited-event-info-trigger.iot:hover + div {
  top: -8rem;
}
.event-timeline-info-header .event-timeline-info .limited-event-info-tooltip {
  display: none;
  background: white;
  width: 30rem;
  border: 1px solid #cccccc;
  border-radius: 0.3rem;
  padding: 1rem;
  top: 9.5rem;
  right: 0;
  line-height: 1.2rem;
}
.event-timeline-info-header .event-timeline-info .limited-event-info-tooltip p:not(:last-child) {
  padding-bottom: 0.5rem;
}

.event-timeline-tooltip {
  padding: 1rem;
  font-size: 1rem;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.85);
  color: rgb(10%, 10%, 10%);
  min-width: 20rem;
}
.event-timeline-tooltip > * + * {
  margin-top: 0.5rem;
}
.event-timeline-tooltip__fixed-width-label {
  width: 50px;
  display: inline-block;
}
.event-timeline-tooltip__severity {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-transform: capitalize;
  color: #000;
  font-weight: 500;
}
.event-timeline-tooltip__severity--critical {
  color: #f03040;
}
.event-timeline-tooltip__severity--warning {
  color: #ffd800;
}
.event-timeline-tooltip__details {
  margin: 0.5rem 1.25rem;
  line-height: 1.25;
}
.event-timeline-tooltip__details div span {
  min-width: 6rem;
  display: inline-block;
  font-size: 14px;
}
.event-timeline-tooltip__details div span:first-child {
  color: #808080;
}
.event-timeline-tooltip__details div span:last-child {
  color: #000000;
}
.event-timeline-tooltip__severity-groups {
  color: #808080;
  width: 100%;
  margin-top: 1rem;
}
.event-timeline-tooltip__severity-groups > * + * {
  margin-top: 0.5rem;
}
.event-timeline-tooltip__timestamp {
  color: #808080;
}
.event-timeline-tooltip__duration {
  display: flex;
  align-items: center;
}
.event-timeline-tooltip__duration .avt-react-components--icon {
  display: flex;
  align-items: center;
  width: 9px;
  height: 9px;
  margin: 0 0.3rem;
}
.event-timeline-tooltip__name {
  font-weight: 500;
}
.event-timeline-tooltip__indicators {
  display: flex;
  justify-content: flex-end;
}
.event-timeline-tooltip__indicators--comments, .event-timeline-tooltip__indicators--attachments {
  position: relative;
  margin-right: 1rem;
}
.event-timeline-tooltip__indicators--comments .pill-component, .event-timeline-tooltip__indicators--attachments .pill-component {
  position: absolute;
  top: -0.4rem;
  right: -0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.4rem;
  height: 1.1rem;
  border-radius: 50%;
}
.event-timeline-tooltip__indicators--comments .pill-component .text, .event-timeline-tooltip__indicators--attachments .pill-component .text {
  margin-left: 0;
}

.tooltip-box {
  border-radius: 0.25rem;
  font-size: 0.86rem;
  padding: 0.35rem 0.5rem 0.4rem 0.5rem;
  word-break: break-word;
  white-space: normal;
  text-align: center;
  overflow-wrap: break-word;
}
.tooltip-box.theme-light {
  background-color: #333333;
  color: #ffffff;
}
.tooltip-box.theme-dark {
  background-color: rgb(95%, 95%, 95%);
  color: black;
}

body.select-none {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.event-timeline-chart-area {
  position: relative;
  margin-bottom: 1rem;
}
.event-timeline-chart-area .iot-event-option {
  display: flex;
  align-items: center;
}
.event-timeline-chart-area .iot-event-option div:not(:last-child) {
  margin-right: 0.5rem;
}

.timeline-chart-event {
  cursor: pointer;
}

.event-timeline-list-container {
  overflow-y: hidden;
  height: 100%;
  min-height: 0;
}
.event-timeline-list-container.limited {
  overflow-x: hidden;
}
.event-timeline-list-container:not(.limited) {
  position: relative;
}

.event-timeline-event-list {
  border: 1px solid rgba(89, 89, 89, 0.3);
  height: 100%;
}
.event-timeline-event-list.limit-list {
  border: none;
}
.event-timeline-event-list--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.event-timeline-event-list .list-view {
  width: 100% !important;
  overflow-y: scroll !important;
}

.event-timeline-event-list-headers {
  display: flex;
  font-weight: 500;
  background: rgb(95%, 95%, 95%);
  color: rgb(10%, 10%, 10%);
  border-bottom: 1px solid rgba(89, 89, 89, 0.3);
}
.event-timeline-event-list-headers .list-header {
  padding: 0.5rem 0.7rem 0.5rem 0.5rem;
  border-right: 0.2rem solid #ffffff;
  box-sizing: border-box;
}
.event-timeline-event-list-headers .list-header:last-child, .event-timeline-event-list-headers .list-header:nth-last-child(2) {
  border-right: none;
}
.event-timeline-event-list-headers .list-header.date-column {
  flex: 4 0 215px;
  min-width: 215px;
}
.event-timeline-event-list-headers .list-header.date-column.avt-react-components--button {
  padding: 0.5rem 0.7rem 0 0.5rem;
  flex: 4 0 215px;
  min-width: 215px;
  border-top: none;
  border-left: none;
  align-items: flex-start;
  line-height: 16px;
}
.event-timeline-event-list-headers .list-header.date-column.avt-react-components--button .avt-react-components--icon {
  display: flex;
  flex-direction: column;
  top: 2px;
  left: 4px;
  position: relative;
}
.event-timeline-event-list-headers .list-header.active-column, .event-timeline-event-list-headers .list-header.activity-column, .event-timeline-event-list-headers .list-header.state-column {
  flex: 1 0 85px;
  min-width: 85px;
}
.event-timeline-event-list-headers .list-header.type-column, .event-timeline-event-list-headers .list-header.pointId-column, .event-timeline-event-list-headers .list-header.sender-column, .event-timeline-event-list-headers .list-header.assignedTo-column, .event-timeline-event-list-headers .list-header.messageType-column, .event-timeline-event-list-headers .list-header.algorithmName-column, .event-timeline-event-list-headers .list-header.algorithmType-column, .event-timeline-event-list-headers .list-header.additionalIdentifier-column, .event-timeline-event-list-headers .list-header.deviatingReferenceDesignation-column, .event-timeline-event-list-headers .list-header.recommendation-column {
  flex: 4 1 165px;
  min-width: 150px;
}
.event-timeline-event-list-headers .list-header.group-column, .event-timeline-event-list-headers .list-header.message-column {
  flex: 6 2 250px;
  min-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.event-timeline-event-list-headers .list-header.label-column {
  flex: 2 1 120px;
  min-width: 100px;
}
.event-timeline-event-list-headers .list-header.actions-column {
  flex: 1 0 85px;
  min-width: 85px;
  padding: 0.5rem;
}
.event-timeline-event-list-headers .list-header.scroll-spacer {
  flex: 0 0 6px;
  padding: 0;
}

.event-timeline-list-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(89, 89, 89, 0.3);
  border-right: 1px solid rgba(89, 89, 89, 0.3);
  width: calc(100% - 2px);
}
.event-timeline-list-item.overdue {
  background-color: #ec575b;
}
.event-timeline-list-item.todo {
  background-color: #ede27f;
}
.event-timeline-list-item__date {
  display: flex;
  flex: 4 0 215px;
  min-width: 215px;
  align-items: center;
  line-height: 1.3rem;
  padding: 0 0.5rem;
}
.event-timeline-list-item__type {
  flex: 4 1 165px;
  min-width: 150px;
  line-height: 1.3rem;
  text-transform: capitalize;
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.event-timeline-list-item__group, .event-timeline-list-item__message {
  flex: 6 2 250px;
  min-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3rem;
  padding: 0 0.5rem;
}
.event-timeline-list-item__label {
  flex: 2 1 120px;
  min-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3rem;
  padding: 0 0.5rem;
}
.event-timeline-list-item__label .event-label {
  border-radius: 4px;
  background: rgb(90%, 90%, 90%);
  padding-inline: 8px;
  display: inline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.event-timeline-list-item__active, .event-timeline-list-item__activity, .event-timeline-list-item__state, .event-timeline-list-item__actions {
  flex: 1 0 85px;
  min-width: 85px;
  padding: 0 0.5rem;
}
.event-timeline-list-item__sender, .event-timeline-list-item__assignedTo, .event-timeline-list-item__pointId, .event-timeline-list-item__messageType, .event-timeline-list-item__algorithmName, .event-timeline-list-item__algorithmType, .event-timeline-list-item__additionalIdentifier, .event-timeline-list-item__deviatingReferenceDesignation, .event-timeline-list-item__recommendation {
  flex: 4 1 165px;
  min-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3rem;
  padding: 0 0.5rem;
}
.event-timeline-list-item--limited-list {
  flex-direction: column;
  justify-content: center;
  padding: 0.5rem 1rem;
  border: 0;
  border-radius: 0.3rem;
  height: 60px;
  background-color: rgb(95%, 95%, 95%);
}
.event-timeline-list-item--limited-list > div {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 0 0.5rem;
}
.event-timeline-list-item--limited-list > div:not(:last-child) {
  padding-bottom: 0.3rem;
}
.event-timeline-list-item--limited-list .event-timeline-list-item_type {
  flex: 1;
}
.event-timeline-list-item--limited-list .event-timeline-list-item__date,
.event-timeline-list-item--limited-list .event-timeline-list-item__actions {
  flex: 1;
  justify-content: flex-end;
}
.event-timeline-list-item--limited-list .event-timeline-list-item__actions .event-timeline-user-event-status {
  justify-content: flex-end;
}
@media only screen and (max-width: 1330px) {
  .event-timeline-list-item--limited-list-narrow {
    justify-content: flex-start;
    height: 77px;
  }
  .event-timeline-list-item--limited-list-narrow > div {
    align-items: flex-start;
  }
  .event-timeline-list-item--limited-list-narrow > div:not(:last-child) {
    flex-direction: column;
    padding-bottom: 0;
  }
  .event-timeline-list-item--limited-list-narrow > div > div {
    padding-bottom: 0.5rem;
    padding-left: 0;
  }
  .event-timeline-list-item--limited-list-narrow .event-timeline-list-item__date {
    padding-bottom: 0.4rem;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1330px) {
  .event-timeline-list-item--limited-list-narrow {
    height: 82px;
  }
}
.event-timeline-list-item--loading {
  display: flex;
  align-items: center;
  justify-content: center;
}
.event-timeline-list-item--clickable {
  cursor: pointer;
}
.event-timeline-list-item--critical {
  background-color: #f8d9d8;
}
.event-timeline-list-item--warning {
  background-color: #fef7de;
}
.event-timeline-list-item--hovering {
  box-shadow: inset 0px 0px 0.5px 1.5px #3366ff;
  z-index: 1;
}
.event-timeline-list-item--limited-list.event-timeline-list-item--hovering {
  box-shadow: none;
  background-color: rgb(90%, 90%, 90%);
}

.limited-list-wrapper {
  display: block;
}
.limited-list-wrapper .event-timeline-list-item__message {
  display: flex;
  align-items: center;
  max-width: 75%;
}
.limited-list-wrapper .event-timeline-list-item__message > div:first-child {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-timeline-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-end;
}
@media only screen and (min-width: 1770px) {
  .event-timeline-filters {
    margin-left: 0;
  }
}
.event-timeline-filters .popout-select--trigger.round svg {
  color: rgb(70%, 70%, 70%);
}
.event-timeline-filters .avt-react-components--input {
  line-height: 1rem;
  height: calc(1rem + 1px);
  box-sizing: content-box;
  padding: 0.5rem;
  width: 12rem;
}
.event-timeline-filters .avt-react-components--input:hover:not(:focus) {
  border-color: rgb(70%, 70%, 70%);
}
.event-timeline-filters .avt-react-components--input::placeholder {
  color: #666666;
  font-weight: 400;
}
.event-timeline-filters .select-period-component .header {
  box-sizing: border-box;
  width: 100%;
}

.event-timeline-panel-header {
  margin-bottom: 1rem;
}
.event-timeline-panel-header .event-timeline-panel-toolbar {
  display: flex;
  gap: 0.5rem;
  width: 100%;
  align-items: flex-start;
  margin-bottom: 0.5rem;
  justify-content: space-between;
}
.event-timeline-panel-header .event-timeline-panel-toolbar .event-timeline-panel-btn-wrapper {
  display: flex;
  gap: 0.5rem;
}
.event-timeline-panel-header .event-timeline-panel-toolbar .event-timeline-filters .event-timeline-search {
  display: flex;
  align-items: flex-end;
  width: 23%;
}
.event-timeline-panel-header .event-timeline-panel-toolbar .event-timeline-filters .event-timeline-search .avt-react-components--input {
  width: 100%;
  height: 1rem;
}
@media only screen and (max-width: 1305px) {
  .event-timeline-panel-header.wide .event-timeline-panel-toolbar .event-timeline-filters .avt-react-components--input {
    width: 100%;
  }
}
@media only screen and (max-width: 840px) {
  .event-timeline-panel-header.widest .event-timeline-panel-toolbar button:nth-child(2) {
    padding: 0 0.4rem;
  }
  .event-timeline-panel-header.widest .event-timeline-panel-toolbar button:nth-child(2) .avt-react-components--icon {
    margin-right: 0;
  }
  .event-timeline-panel-header.widest .event-timeline-panel-toolbar button:nth-child(2) .button-text {
    display: none;
  }
}

.event-timeline-user-event-status {
  display: flex;
  justify-content: space-evenly;
}

.severity-indicator {
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}
.severity-indicator--panel {
  margin-right: 0;
}

.related-events {
  height: 124.5px;
}
.related-events.empty {
  height: 0px;
}
.related-events__list .avt-react-components--button,
.related-events__list .event-count {
  margin-top: 1rem;
  font-size: 0.75rem;
}
.related-events__list .event-count {
  display: flex;
  justify-content: center;
  color: #666666;
}
.related-events__display-item {
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
}
.related-events__display-item.clickable {
  cursor: pointer;
}
.related-events__display-item > *:first-child {
  flex: 0 0 auto;
  margin: 0 10px;
}
.related-events p {
  min-height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.related-events__see-all {
  display: block;
  margin: 0 auto;
}
.related-events__buttons {
  display: flex;
  margin-top: 1rem;
}
.related-events__buttons button {
  margin-right: 0.5rem;
}
.related-events__list-container {
  overflow-x: auto;
  overflow-y: hidden;
}

.related-events-modal__event-filters {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}
.related-events-modal__event-filters .related-events__search {
  padding-right: 0.5rem;
  width: 19rem;
}
.related-events-modal__event-filters .related-events__search .avt-react-components--input {
  height: 2.2rem;
}
.related-events-modal__event-filters .popout-select .avt-react-components--button.design-outlined.activity-tertiary.popout-select--trigger {
  background: #ffffff;
}
.related-events-modal__event-filters .select-period-component {
  background-color: #ffffff;
}
.related-events-modal__event-filters .event-timeline-filters {
  width: auto;
}
.related-events-modal__date-span {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.5rem;
}
.related-events-modal__date-span > .avt-react-components--icon {
  margin: 0 0.5rem;
}
.related-events-modal__date-time {
  display: flex;
}
.related-events-modal__date-time .date-picker .SingleDatePickerInput {
  padding: 0.3rem 0.5rem;
  color: rgb(10%, 10%, 10%);
}
.related-events-modal__date-time .date-picker .SingleDatePickerInput input {
  width: auto;
}
.related-events-modal__date-time .time-picker {
  padding: 0.3rem 0.5rem 0.3rem 0.3rem;
}
.related-events-modal__date-time > * + * {
  margin-left: 0.5rem;
}
.related-events-modal .valid-date .DateInput_input {
  color: rgb(10%, 10%, 10%);
}
.related-events-modal__date-time + .related-events-modal__date-time {
  margin-left: 0.5rem;
}
.related-events-modal__buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}
.related-events-modal__buttons button {
  margin-right: 0.5rem;
}
@media only screen and (max-width: 1350px) {
  .related-events-modal__event-filters {
    flex-direction: column;
    align-items: flex-end;
  }
  .related-events-modal__event-filters .related-events__search {
    margin-bottom: 0.5rem;
    padding-right: 0;
  }
  .related-events-modal__date-span {
    margin-bottom: 0.5rem;
  }
}

.light-theme .drop-zone {
  background: rgba(255, 255, 255, 0.9);
}

.dark-theme .drop-zone {
  background: rgba(10%, 10%, 10%, 0.9);
}
.dark-theme .event-timeline-domain-display {
  color: #666666;
}
.dark-theme .event-timeline-tooltip,
.dark-theme .tooltip-detail {
  background-color: rgba(15%, 15%, 15%, 0.85);
  color: rgb(90%, 90%, 90%);
}
.dark-theme .event-timeline-event-list-headers {
  background: rgb(15%, 15%, 15%);
  color: rgb(90%, 90%, 90%);
}
.dark-theme .event-timeline-event-list-headers :not(:last-child) {
  border-right: 0.2rem solid rgb(10%, 10%, 10%);
}
.dark-theme .event-timeline-list-item {
  background-color: rgb(10%, 10%, 10%);
  border-bottom: 1px solid rgba(65%, 65%, 65%, 0.3);
}
.dark-theme .event-timeline-list-item--critical {
  background-color: rgba(240, 48, 64, 0.15);
}
.dark-theme .event-timeline-list-item--warning {
  background-color: rgba(255, 216, 0, 0.1);
}
.dark-theme .event-timeline-list-item--limited-list {
  border: 0;
}
.dark-theme .event-timeline-list-item__label .event-label {
  color: black;
}
.dark-theme .event-timeline-list-item.event-timeline-list-item--limited-list {
  background-color: rgb(15%, 15%, 15%);
}
.dark-theme .event-timeline-list-item.event-timeline-list-item--limited-list.event-timeline-list-item--hovering {
  box-shadow: none;
  background-color: rgb(25%, 25%, 25%);
}
.dark-theme .event-timeline-filters .popout-select--trigger.round svg {
  color: #666666;
}
.dark-theme .event-timeline-filters .avt-react-components--input:hover:not(:focus) {
  border-color: #666666;
}
.dark-theme .event-timeline-filters .avt-react-components--input::placeholder {
  color: #666666;
}
.dark-theme .related-events__list .event-count {
  color: rgb(50%, 50%, 50%);
}
.dark-theme .related-events-modal__event-filters .popout-select .avt-react-components--button.design-outlined.activity-tertiary.popout-select--trigger {
  background: rgb(10%, 10%, 10%);
}
.dark-theme .related-events-modal__date-time .date-picker .SingleDatePickerInput {
  color: rgb(90%, 90%, 90%);
}
.dark-theme .related-events-modal .valid-date .DateInput_input {
  color: rgb(90%, 90%, 90%);
}
.dark-theme .related-events-modal__date-span > div > input::-webkit-calendar-picker-indicator {
  filter: invert(1);
}
.dark-theme .event-timeline-tooltip__details div span {
  color: rgb(90%, 90%, 90%);
}
.dark-theme .event-timeline-tooltip__severity {
  color: rgb(90%, 90%, 90%);
}

.event-timeline-narrow-unsupported {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  text-align: center;
}
.event-timeline-narrow-unsupported p {
  margin: 0;
  font-size: 0.875rem;
  opacity: 0.7;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */